var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5.5C1.2.2.8.2.6.5c-.3.3-.3.7 0 .9l4 4c.3.3.7.3.9 0l4-4c.3-.3.3-.7 0-.9-.3-.3-.7-.3-.9 0L5 4.1 1.5.5z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
};
export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMCA2Ij4KICAgIDxwYXRoIGQ9Ik0xLjUuNUMxLjIuMi44LjIuNi41Yy0uMy4zLS4zLjcgMCAuOWw0IDRjLjMuMy43LjMuOSAwbDQtNGMuMy0uMy4zLS43IDAtLjktLjMtLjMtLjctLjMtLjkgMEw1IDQuMSAxLjUuNXoiCiAgICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4='";